import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana27Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1468_40283)"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("6"))}
    d="M331.771 548.974L449.952 499.116L341.004 471.417L331.771 548.974Z" 
    fill={getFillByLot(6, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("7"))}    
    d="M346.541 416.02L341.001 471.417L394.552 484.342L411.171 408.633C404.4 406.787 386.796 402.355 370.546 399.401C354.296 396.446 347.772 409.249 346.541 416.02Z" 
    fill={getFillByLot(7, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("8"))}    
    d="M468.41 423.406L411.166 408.634L394.547 484.343L449.944 499.116L468.41 423.406Z" 
    fill={getFillByLot(8, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("5"))}    
    d="M326.227 600.679L331.767 548.975L377.931 530.509L403.783 595.139L339.153 617.298C327.335 617.298 325.612 606.219 326.227 600.679Z" 
    fill={getFillByLot(5, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("4"))}    
    d="M462.876 571.131L403.786 595.136L377.934 530.506L435.177 506.501L462.876 571.131Z" 
    fill={getFillByLot(4, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("3"))}    
    d="M518.278 547.127L462.881 571.132L435.183 506.502L492.426 482.497L518.278 547.127Z" 
    fill={getFillByLot(3, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("2"))}    
    d="M573.665 521.274L518.268 547.126L492.416 482.496L547.813 458.491L573.665 521.274Z" 
    fill={getFillByLot(2, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M641.996 488.034L573.672 521.272L547.82 458.489L569.979 447.409L634.609 460.335C649.382 469.199 645.689 482.494 641.996 488.034Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("9"))}    
    d="M468.418 423.405L569.979 447.41L449.952 499.114L468.418 423.405Z" 
    fill={getFillByLot(9, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1468_40283" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1468_40283" transform="matrix(0.00253288 0 0 0.00335792 -4.43168 -1.09288)"/>
    </pattern>
    <image id="image0_1468_40283" width="4096" height="2304" href="/mz2.png"/>
    </defs>
  </svg>
  );
};